import { Component, forwardRef, inject, Signal } from '@angular/core';
import { TimeReportDialogService } from '@app/components/time-reports/time-report-dialog/time-report-dialog.service';
import { FileHorizontalListComponent } from '@app/shared/components/files/file-horizontal-list/file-horizontal-list.component';
import { FilePreviewListComponent } from '@app/shared/components/files/file-preview-list/file-preview-list.component';
import { FileInfo } from '@app/shared/types/models/files/file-info';
import { FileUploadInfo } from '@app/shared/types/models/files/file-upload-info';
import { UiFileDropZoneComponent } from '@app/shared/ui/file-drop-zone/ui-file-drop-zone.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'proffeo-time-report-file-attachments',
  templateUrl: './time-report-file-attachments.component.html',
  imports: [
    TranslatePipe,
    FilePreviewListComponent,
    UiFileDropZoneComponent,
    forwardRef(() => FileHorizontalListComponent)
  ]
})
export class TimeReportFileAttachmentsComponent {
  private readonly timeReportDialogService: TimeReportDialogService = inject(TimeReportDialogService);
  protected readonly isAddingNewReport: Signal<boolean> = this.timeReportDialogService.isAddingNewReport;
  protected readonly previewFiles: Signal<File[]> = this.timeReportDialogService.previewFiles;
  protected readonly files: Signal<FileInfo[]> = this.timeReportDialogService.files;
  protected readonly uploadingFiles: Signal<FileUploadInfo[]> = this.timeReportDialogService.uploadingFiles;

  protected onAddPreviewFiles(files: File[]): void {
    this.timeReportDialogService.addPreviewFiles(files);
  }

  protected onRemovePreviewFile(fileToRemove: File): void {
    this.timeReportDialogService.removePreviewFile(fileToRemove);
  }

  protected onDeleteFile(file: FileInfo): void {
    this.timeReportDialogService.deleteFile(file);
  }

  protected onUploadFiles(files: File[]): void {
    this.timeReportDialogService.uploadFiles(files);
  }
}
